import styles from "./styles/ReportsHeader.module.scss";

export default function ReportsHeader() {
  return (
    <>
      <span className={styles.header}>گزارش ها</span>
    </>
  );
}
